import { render, staticRenderFns } from "./InvoiceFreight.vue?vue&type=template&id=630f7808&"
import script from "./InvoiceFreight.vue?vue&type=script&lang=js&"
export * from "./InvoiceFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports